import { IonContent, IonIcon, IonPage } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ReduxCommandCreator } from 'appRedux/actions';
import { IState, IUserInfo } from 'appRedux/createStore';
import { casinoIdListEnum } from 'common/commonEnum';
import { AuthService } from 'services/auth';
import { S3_PROFILE_BASE } from 'common/common';

export const S3_BASE = S3_PROFILE_BASE;

const AVATAR_COUNT = 19;
const BG_COUNT = 9;

const getCasinoHeaderBg = (casinoId: number): string => {
  switch (casinoId) {
    case casinoIdListEnum.LOTC:
    case casinoIdListEnum.EUREKA:
      return '/assets/images/header-lotc-bg.png';
    case casinoIdListEnum.RWC:
    case casinoIdListEnum.ACH:
      return '/assets/images/header-rwc-bg.png';
    case casinoIdListEnum.SSC:
      return '/assets/images/header-ssc-bg.png';
    default:
      return '/assets/images/bg-choose-casino.png';
  }
};

const SetIcon: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const commands = ReduxCommandCreator(dispatch);

  const casinoId = useSelector<IState>(
    (state) => state.app.persistedState.casinoSchema?.kpCasinoPk
  ) as number;

  const { avatarId: savedAvatarId, avatarBgId: savedAvatarBgId } = useSelector<IState>(
    (state) => state.app.persistedState.userInfo
  ) as IUserInfo;

  const [selectedAvatarId, setSelectedAvatarId] = useState<number>(savedAvatarId ?? 1);
  const [selectedBgId, setSelectedBgId] = useState<number>(savedAvatarBgId ?? 1);

  const headerBg = getCasinoHeaderBg(casinoId);

  const handleAvatarSelect = (id: number) => setSelectedAvatarId(id);
  const handleBgSelect = (bgId: number) => setSelectedBgId(bgId);

  const handleConfirm = () => {
    commands.SetUserAvatar(selectedAvatarId, selectedBgId);
    const authService = new AuthService();
    authService.UpdateMe({ avatarId: selectedAvatarId, avatarBgId: selectedBgId }).subscribe();
    history.goBack();
  };

  return (
    <IonPage className="set-icon-page app-parent">
      <div
        className="set-icon-hero"
        style={{ '--hero-bg': `url(${headerBg})` } as React.CSSProperties}
      >
        <div className="set-icon-nav">
          <button
            className="set-icon-back-btn"
            onClick={() => history.goBack()}
            aria-label="Go back"
          />
          <button
            className="set-icon-confirm-btn"
            onClick={handleConfirm}
            aria-label="Confirm selection"
          >
            <IonIcon icon={checkmark} className="set-icon-confirm-icon" />
          </button>
        </div>

        <div className="set-icon-preview-wrap">
          <div
            className="set-icon-preview-circle"
            style={{ backgroundImage: `url(${S3_BASE}/avatar-bg${selectedBgId}.png)` }}
          >
            <img
              src={`${S3_BASE}/avatar${selectedAvatarId}.png`}
              alt="selected avatar"
              className="set-icon-preview-img"
            />
          </div>
        </div>

        <p className="set-icon-title-text">Set Icon</p>
        <div className="set-icon-divider" />
      </div>

      <IonContent className="set-icon-scroll">
        <div className="set-icon-content">
          <div className="set-icon-grid">
            {Array.from({ length: AVATAR_COUNT }, (_, i) => i + 1).map((id) => {
              const isSelected = selectedAvatarId === id;
              return (
                <div
                  key={id}
                  className={`set-icon-item${isSelected ? ' set-icon-item--selected' : ''}`}
                  onClick={() => handleAvatarSelect(id)}
                >
                  <div
                    className="set-icon-avatar"
                    style={{ backgroundImage: `url(${S3_BASE}/avatar-bg${selectedBgId}.png)` }}
                  >
                    <img
                      src={`${S3_BASE}/avatar${id}.png`}
                      alt={`Avatar ${id}`}
                      className="set-icon-avatar-img"
                    />
                    {isSelected && (
                      <span className="set-color-check-badge">
                        <IonIcon icon={checkmark} className="set-color-check-icon" />
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="set-color-section">
            <div className="set-color-label">Set Color</div>
            <div className="set-color-row">
              {Array.from({ length: BG_COUNT }, (_, i) => i + 1).map((bgId) => {
                const isSelected = selectedBgId === bgId;
                return (
                  <div
                    key={bgId}
                    className={`set-color-item${isSelected ? ' set-color-item--selected' : ''}`}
                    onClick={() => handleBgSelect(bgId)}
                  >
                    <div
                      className="set-color-circle"
                      style={{ backgroundImage: `url(${S3_BASE}/avatar-bg${bgId}.png)` }}
                    >
                      {isSelected && (
                        <span className="set-color-check-badge">
                          <IonIcon icon={checkmark} className="set-color-check-icon" />
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SetIcon;
